import { get } from "../index";
import DashboardRoutes from "./Dashboard.routes";

const DashboardServices = {
  getStats: async () => {
    const result = await get(DashboardRoutes.getStats);
    return result;
  },

  getBlogCounts: async () => {
    const result = await get(DashboardRoutes.getBlogStats);
    return result;
  }
}

export default DashboardServices;